import { IDomain } from '../../types';
import {
  GET_DOMAINS_REQUEST,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAILURE,
  CREATE_DOMAIN_REQUEST,
  CREATE_DOMAIN_SUCCESS,
  CREATE_DOMAIN_FAILURE,
  GET_DOMAIN_REQUEST,
  GET_DOMAIN_SUCCESS,
  GET_DOMAIN_FAILURE,
  VERIFY_DOMAIN_REQUEST,
  VERIFY_DOMAIN_SUCCESS,
  VERIFY_DOMAIN_FAILURE,
  DELETE_DOMAIN_REQUEST,
  DELETE_DOMAIN_SUCCESS,
  DELETE_DOMAIN_FAILURE,
  DomainActionTypes,
  CLEAR_DOMAIN_STATE,
} from './domain.types';

export interface DomainState {
  domains: IDomain[];
  selectedDomain: IDomain | null;
  loading: boolean;
  verificationLoading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: DomainState = {
  domains: [],
  selectedDomain: null,
  loading: false,
  verificationLoading: false,
  error: null,
  success: false,
};

const domainReducer = (
  state: DomainState = initialState,
  action: DomainActionTypes
): DomainState => {
  switch (action.type) {
    case GET_DOMAINS_REQUEST:
    case GET_DOMAIN_REQUEST:
    case DELETE_DOMAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_DOMAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case VERIFY_DOMAIN_REQUEST:
      return {
        ...state,
        verificationLoading: true,
        error: null,
      };

    case GET_DOMAINS_SUCCESS:
      return {
        ...state,
        loading: false,
        domains: action.payload,
        error: null,
      };

    case GET_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedDomain: action.payload,
        error: null,
      };

    case CREATE_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        domains: [...state.domains, action.payload],
        error: null,
        success: true,
      };

    case VERIFY_DOMAIN_SUCCESS:
      return {
        ...state,
        verificationLoading: false,
        domains: state.domains.map((domain) =>
          domain._id === action.payload._id ? action.payload : domain
        ),
        error: null,
      };

    case DELETE_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        domains: state.domains.filter(
          (domain) => domain._id !== action.payload
        ),
        selectedDomain: null,
        error: null,
      };
    case CREATE_DOMAIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case CLEAR_DOMAIN_STATE:
      return {
        ...state,
        success: false,
        error: null,
      };
    case GET_DOMAINS_FAILURE:
    case GET_DOMAIN_FAILURE:
    case DELETE_DOMAIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VERIFY_DOMAIN_FAILURE:
      return {
        ...state,
        verificationLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default domainReducer;
